import { ImSpinner2 } from 'react-icons/im';

import styled, { keyframes } from 'styled-components';

const animate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(720deg);
  }
`;

export const Spinner = styled(ImSpinner2)`
  padding: 10px;
  width: 60px;
  height: 60px;
  animation: ${animate} 2s infinite;
`;

export const SpinnerContainer = styled.div`
  display: flex;
  padding: 20px 0;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const FileLink = styled.a`
  word-break: break-all;
`;
